import mq from 'js-mq'
import $ from 'jquery';

$(_ => {

  const $mobileInsertTarget = $('#mobile-menu-insert-target');

  if ($mobileInsertTarget === 0) return;

  let isMobile = false;

  const $navMain = $('#nav-main');
  const $navMainContainer = $('#nav-main-container');
  const $buyTix = $('#buy-tix-popout');
  const $buyTixContainer = $('#buy-tix-popout-container');

  function updateForMobile() {
    if (isMobile) return;

    window.requestAnimationFrame(_ => {
      $mobileInsertTarget.append($navMain);
      $mobileInsertTarget.append($buyTix);
      isMobile = true;
    });
  }

  function updateForOthers() {
    if (!isMobile) return;

    window.requestAnimationFrame(_ => {
      $navMainContainer.append($navMain);
      $buyTixContainer.append($buyTix);
      isMobile = false;
    });
  }

  mq.on('nav-main-mobile', updateForMobile, updateForOthers);

});